"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./InlineCalender.css");

require("./FullCalender.css");

var _TenYearCalender = _interopRequireDefault(require("./TenYearCalender"));

var _YearCalender = _interopRequireDefault(require("./YearCalender"));

var _MonthCalender = _interopRequireDefault(require("./MonthCalender"));

var _InlineCalender2 = _interopRequireDefault(require("./InlineCalender"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
} // import { CSSTransition } from "react-transition-group";
// import TransitionGroup from 'react-transition-group/TransitionGroup' // ES6


var FullCalenderVertical =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FullCalenderVertical, _React$Component);

  function FullCalenderVertical(props) {
    var _this;

    _classCallCheck(this, FullCalenderVertical);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FullCalenderVertical).call(this, props));
    _this.state = {
      level: 0,
      month: "",
      day: "",
      tenYear: "",
      year: ""
    };
    _this.clickTitle = _this.clickTitle.bind(_assertThisInitialized(_this));
    _this.clickTitleMonth = _this.clickTitleMonth.bind(_assertThisInitialized(_this));
    _this.clickTitleYear = _this.clickTitleYear.bind(_assertThisInitialized(_this));
    _this.getMainVal = _this.getMainVal.bind(_assertThisInitialized(_this));
    _this.getCurrentYearMonth = _this.getCurrentYearMonth.bind(_assertThisInitialized(_this));
    _this.selectedYearM = _this.selectedYearM.bind(_assertThisInitialized(_this));
    _this.selectedYear = _this.selectedYear.bind(_assertThisInitialized(_this));
    _this.selectedMonth = _this.selectedMonth.bind(_assertThisInitialized(_this));
    _this.selectedTenYear = _this.selectedTenYear.bind(_assertThisInitialized(_this));
    _this.getCurrentYear = _this.getCurrentYear.bind(_assertThisInitialized(_this));
    _this.mCreator = _this.mCreator.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FullCalenderVertical, [{
    key: "mCreator",
    value: function mCreator() {
      return _react.default.createElement(_react.Fragment, null, this.state.level === 0 && _react.default.createElement(_InlineCalender2.default, {
        isFiveRow: true,
        defYear: this.state.year,
        defMonth: this.state.month,
        input: this.getMainVal,
        "v-bind": "!!inlineStyle ? inlineStyle : {}",
        getCurrentYear: this.getCurrentYear,
        clickTitle: this.clickTitle
      }), this.state.level === 1 && _react.default.createElement(_MonthCalender.default, {
        "v-bind": "!!monthStyle ? monthStyle : {}",
        defYear: this.state.year,
        getCurrentYear: this.getCurrentYearMonth,
        sYear: this.selectedYearM,
        sMonth: this.selectedMonth,
        clickTitle: this.clickTitleMonth
      }), this.state.level === 2 && _react.default.createElement(_YearCalender.default, {
        "v-bind": "!!yearStyle ? yearStyle : {}",
        defYear: this.state.tenYear,
        input: this.selectedYear,
        clickTitle: this.clickTitleYear
      }), this.state.level > 2 && _react.default.createElement(_TenYearCalender.default, {
        defYear: this.state.year,
        input: this.selectedTenYear
      }));
    }
  }, {
    key: "clickTitle",
    value: function clickTitle() {
      // this.anime = this.animUp;
      // this.level = 1;
      this.setState({
        level: 1
      });
    }
  }, {
    key: "clickTitleYear",
    value: function clickTitleYear() {
      // this.anime = this.animUp;
      // this.level = 3;
      this.setState({
        level: 3
      });
    }
  }, {
    key: "clickTitleMonth",
    value: function clickTitleMonth() {
      // this.anime = this.animUp;
      // this.level = 2;
      this.setState({
        level: 2
      });
    }
  }, {
    key: "getMainVal",
    value: function getMainVal(val) {
      this.props.input(val); // this.$emit("input", val);
    }
  }, {
    key: "getCurrentYearMonth",
    value: function getCurrentYearMonth(val) {
      // this.tenYear = val;
      // this.anime = "this.animDown";
      // this.level = 1;
      this.setState({
        tenYear: val // level: 1

      });
    }
  }, {
    key: "selectedYearM",
    value: function selectedYearM(val) {
      // this.year = val;
      this.setState({
        year: val
      });
    }
  }, {
    key: "selectedYear",
    value: function selectedYear(val) {
      this.year = val; // this.anime = this.animDown;

      this.level = 1;
      this.setState({
        year: val,
        level: 1
      });
    }
  }, {
    key: "selectedMonth",
    value: function selectedMonth(val) {
      ////////console.log(val);
      // this.month = val;
      // this.anime = this.animDown;
      // ////////////////console.log(val," ffffffsagwgh")
      // this.level = 0;
      this.setState({
        month: val,
        level: 0
      });
    }
  }, {
    key: "selectedTenYear",
    value: function selectedTenYear(val) {
      // this.tenYear = val;
      // this.anime = this.animDown;
      // this.level = 2;
      this.setState({
        tenYear: val,
        level: 2
      });
    }
  }, {
    key: "getCurrentYear",
    value: function getCurrentYear(val) {
      // this.year = val;
      this.setState({
        year: val // level: 2

      }); //   ////////////////console.log('ffffffffffaga')
    }
  }, {
    key: "render",
    value: function render() {
      // console.log(this.state.level === 0, "level",this.state.level)
      if (this.props.useRaitoSizing) {
        return _react.default.createElement("div", {
          className: "ratio-parent my-font-calender"
        }, _react.default.createElement("div", {
          className: "ratio-child"
        }, _react.default.createElement("div", {
          className: "container-fluid w-100 h-100 overflow-hidden position-relative" // style={mainBodyStyle}

        }, this.mCreator())));
      } else {
        return _react.default.createElement("div", {
          className: "container-fluid my-font-calender",
          style: this.props.mainBodyStyle
        }, this.mCreator());
      }
    }
  }]);

  return FullCalenderVertical;
}(_react.default.Component);

FullCalenderVertical.propTypes = {
  defYear: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  useRaitoSizing: _propTypes.default.bool,
  input: _propTypes.default.func
};
FullCalenderVertical.defaultProps = {
  useRaitoSizing: true,
  input: function input(val) {}
};
var _default = FullCalenderVertical;
exports.default = _default;